import { createAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { all, takeLatest } from 'redux-saga/effects';
import { createFetchAction, createSaga, fetchInitialState, fetchReducerActions } from 'store/utils';

import { setAuthInHeader } from 'api/config/axiosUtils';
import storage, { keys } from 'lib/storage';
import { RootState } from 'store';
import * as supportApi from 'api/support';

interface InitialState {
  faqList: object | any;
  faqDetail: object | any;
  qnaList: object | any;
  updateQna: object | any;
  completeUpdateQna: object | any;
  qnaDetail: object | any;
}

export const fetch_faq_list = createFetchAction('fetch_faq_list');
export const fetch_faq_detail = createFetchAction('fetch_faq_detail');
export const fetch_qna_list = createFetchAction('fetch_qna_list');
export const update_qna = createFetchAction('update_qna');
export const complete_update_qna = createFetchAction('complete_update_qna');
export const fetch_qna_detail = createFetchAction('fetch_qna_detail');

const initialState: InitialState = {
  // NOTE: 최초 랜딩시 storage값 유무 확인
  faqList: { ...fetchInitialState, data: null },
  faqDetail: { ...fetchInitialState, data: null },
  qnaList: { ...fetchInitialState, data: null },
  updateQna: { ...fetchInitialState, data: null },
  completeUpdateQna: { ...fetchInitialState, data: null },
  qnaDetail: { ...fetchInitialState, data: null },
};

const slice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    ...fetchReducerActions(fetch_faq_list, 'faqList'),
    ...fetchReducerActions(fetch_faq_detail, 'faqDetail'),
    ...fetchReducerActions(fetch_qna_list, 'qnaList'),
    ...fetchReducerActions(update_qna, 'updateQna'),
    ...fetchReducerActions(complete_update_qna, 'completeUpdateQna'),
    ...fetchReducerActions(fetch_qna_detail, 'qnaDetail'),
  },
});

export const name = slice.name;
export const actions: any = slice.actions;

export function* supportSaga() {
  yield all([
    takeLatest(
      actions.fetch_faq_list_request,
      createSaga(actions, 'fetch_faq_list', supportApi.fetchFaqList),
    ),
    takeLatest(
      actions.fetch_faq_detail_request,
      createSaga(actions, 'fetch_faq_detail', supportApi.fetchFaqDetail),
    ),
    takeLatest(
      actions.fetch_qna_list_request,
      createSaga(actions, 'fetch_qna_list', supportApi.fetchQnaList),
    ),
    takeLatest(actions.update_qna_request, createSaga(actions, 'update_qna', supportApi.updateQna)),
    takeLatest(
      actions.complete_update_qna_request,
      createSaga(actions, 'complete_update_qna', supportApi.completeUpdateQna),
    ),
    takeLatest(
      actions.fetch_qna_detail_request,
      createSaga(actions, 'fetch_qna_detail', supportApi.fetchQnaDetail),
    ),

    // takeLatest(actions.delete_unit_request, createSaga(actions, 'delete_unit', supportApi.deleteUnit)),
  ]);
}

export default slice.reducer;
